/** @format */

import React, { Component } from 'react';
import Datetime from 'react-datetime';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import I18 from '../Translate/I18n';
import FormHelperText from '@material-ui/core/FormHelperText';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';

import customInputStyle from 'assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

class DatePickerFormRest extends Component {
    render() {
        const { classes, callback, helpText, error, success, id, dateFormat, stateName, typeCallback, required } = this.props;

        const helpTextClasses = classNames({
            [classes.labelRootError]: error,
            [classes.labelRootSuccess]: success && !error,
        });
        return (
            <FormControl classes={{ label: classes.label }} fullWidth={true}>
                <Datetime
                    dateFormat={dateFormat ? dateFormat : 'DD-MM-YYYY'}
                    timeFormat={false}
                    onChange={(moment) => callback(moment, stateName, typeCallback, required)}
                    inputProps={{
                        id: stateName,
                        placeholder: 'DD-MM-YYYY',
                        className: classes.datePickerInput,
                    }}
                />
                {helpText !== undefined ? (
                    <FormHelperText id={id + '-text'} className={helpTextClasses}>
                        <I18 trans={helpText} />
                    </FormHelperText>
                ) : null}
            </FormControl>
        );
    }
}

DatePickerFormRest.propTypes = {
    classes: PropTypes.object.isRequired,
    callback: PropTypes.func.isRequired,
    helpText: PropTypes.string,
    dateFormat: PropTypes.string,
    propValue: PropTypes.string,
    required: PropTypes.bool.isRequired,
    stateName: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    typeCallback: PropTypes.string.isRequired,
};

export default withStyles(oplAppStyle)(DatePickerFormRest);
